import { useEffect, useState } from "react";
import { SERVER_BASE_URL } from "../config";
import { useSelector } from "react-redux";
import { Spin, Table } from "antd";
import { API } from "../config/auth";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import AudioPlayer from "react-h5-audio-player";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import "react-h5-audio-player/lib/styles.css";

const History = () => {
  const organization_id = useSelector((state) => state.config.organization_id);
  const [page, setPage] = useState(1);
  const pageSize = 8;

  const [data, setData] = useState({ logs: [], total: 0 });
  const [loading, setLoading] = useState(true);

  const [recordingData, setRecordingData] = useState(null);

  const columns = [
    {
      title: "From",
      dataIndex: "from_number",
      key: "from_number",
      ellipsis: true,
    },
    {
      title: "To",
      dataIndex: "to_number",
      key: "to_number",
      ellipsis: true,
    },
    {
      title: "Started Time",
      dataIndex: "call_initiated_time",
      key: "call_initiated_time",
      ellipsis: true,
    },
    {
      title: "Ended Time",
      dataIndex: "call_ended_time",
      key: "call_ended_time",
      ellipsis: true,
    },
    {
      title: "Recording",
      dataIndex: "bucket_recording_url",
      key: "bucket_recording_url",
      render: (_, data) => (
        <div>
          {data?.bucket_recording_url ? (
            data?.loading ? (
              <Spin size="small" />
            ) : (
              <PlayArrowIcon
                onClick={() => {
                  setRecordingData(data?.bucket_recording_url);

                  // fetchRecording(data?.call_id, data?.bucket_recording_url)
                }}
                style={{ cursor: "pointer", fontSize: "14px" }}
              />
            )
          ) : (
            ""
          )}
        </div>
      ),
    },
  ];

  // const fetchRecording = async (call_id, recording_link) => {
  //   let logs = data?.logs.map((item) => {
  //     if (item?.call_id === call_id) {
  //       return { ...item, loading: true };
  //     }

  //     return item;
  //   });
  //   setData({ ...data, logs });

  //   await API.get(
  //     `/call/get_recording?url=${encodeURIComponent(
  //       recording_link
  //     )}&organization_id=${organization_id}`,
  //     {
  //       responseType: "blob", //important
  //     }
  //   )
  //     .then((response) => {
  //       const blob = new Blob([response.data], { type: "audio/wav" });
  //       const url = URL.createObjectURL(blob);
  //       setRecordingData(url);
  //     })
  //     .finally(() => {
  //       let logs = data?.logs.map((item) => {
  //         if (item?.call_id === call_id) {
  //           return { ...item, loading: false };
  //         }

  //         return item;
  //       });
  //       setData({ ...data, logs });
  //     });
  // };

  const fetchCallLogs = async (page) => {
    setLoading(true);
    await API.get(
      `${SERVER_BASE_URL}/call/get_call_log?organization_id=${organization_id}&per_page=${pageSize}&page=${page}`
    )
      .then((response) => {
        if (response.data?.success) {
          let logs = response?.data?.data?.logs.map((item) => {
            return { ...item, loading: false };
          });
          setData({ logs: logs, total: response?.data?.data?.total });
        }
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchCallLogs(page);
  }, []);

  const any_recording_loading = data?.logs?.some((item) => item.loading);
  // const any_recording_loading = true;

  console.log(any_recording_loading);

  const downloadButton = (
    <a
      href={recordingData}
      download
      title="Download"
      style={{ marginLeft: 8, color: "inherit" }}
    >
      <CloudDownloadIcon />
    </a>
  );

  return (
    <div className="history_cont">
      <h2>Call History</h2>
      <Table
        dataSource={data?.logs}
        columns={columns}
        size="small"
        loading={loading}
        pagination={{
          onChange: (page) => fetchCallLogs(page),
          total: data?.total,
          pageSize: pageSize,
        }}
      />

      {recordingData ? (
        <div className="history_audio_cont">
          {/* <audio src={recordingData} controls></audio> */}
          {/* <Card style={{ width: "90%" }}> */}
          <AudioPlayer
            src={recordingData}
            showJumpControls={false}
            showFilledProgress={false}
            showFilledVolume
            customAdditionalControls={[downloadButton]}
          />
          {/* </Card> */}
        </div>
      ) : any_recording_loading ? (
        <div className="history_audio_cont">
          <div className="history_audio_spin">
            <Spin />
          </div>
        </div>
      ) : (
        ""
      )}
    </div>
  );
};

export default History;
